(() => {
  if (window.pwPreviewSliderInitialised) return;
  window.pwPreviewSliderInitialised = true;
  function initialise(root) {
    root.querySelectorAll('[data-preview-slider]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-preview-track]');
      function move(direction) {
        track.scrollBy({left: direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
